/**
 * @file Credit Comparison
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Credit Comparison component
 */
const vCreditComparison = () => {
	const creditComparison = document.querySelector( '.v-credit-comparison' );

	if ( ! creditComparison ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const scores           = creditComparison.querySelectorAll( '.v-credit-comparison__score' );
	const highlightContent = creditComparison.querySelectorAll( '.v-highlight-js' );
	const highlightBox     = creditComparison.querySelector( '.v-credit-comparison__box-wrap' );
	const highlightReveal  = gsap.timeline( {
		defaults: {
			ease:     'sine.out',
			duration: 1,
		},
		scrollTrigger: {
			trigger: highlightBox,
			start:   'bottom bottom',
			onEnter: () => {
				setTimeout( () => highlightReveal.timeScale( 1 ), 0 );
			},
			onLeaveBack: () => {
				setTimeout( () => highlightReveal.timeScale( -2 ), 0 );
			},
		},
	} )
		.to( highlightContent, {
			opacity: 1,
			y:       '0%',
		} );

	[ ...scores ].forEach( ( score ) => {
		let isAnimating = false;
		const facts     = score.querySelectorAll( '.v-credit-comparison__fact' );
		const separator = score.querySelector( '.v-credit-comparison__separator' );
		const summary   = score.querySelector( '.v-credit-comparison__summary' );
		const animation = gsap.timeline( {
			defaults: {
				ease:     'sine.out',
				duration: 1,
				onStart:  () => {
					isAnimating = true;
				},
				onComplete: () => {
					isAnimating = false;
				},
			},
		} );

		score.addEventListener( 'vcreditgraphcomplete', ( { detail } ) => {
			const { graph } = detail;

			if ( ! score.contains( graph ) || isAnimating ) {
				return;
			}

			animation.to( [ facts, separator, summary ], {
				opacity:    1,
				y:          '0%',
				stagger:    .2,
				duration:   .5,
				onComplete: () => {
					score.classList.add( 'v-credit-comparison__score--visible' );
				},
			} );
		} );

		score.addEventListener( 'vcreditgraphreverse', ( { detail } ) => {
			const { graph } = detail;

			if ( ! score.contains( graph ) ) {
				return;
			}

			if ( isAnimating ) {
				animation.progress( 1 );
				isAnimating = false;
			}

			score.classList.remove( 'v-credit-comparison__score--visible' );

			[ ...[ ...facts ].flat(), separator, summary ].forEach( ( el ) => {
				el.removeAttribute( 'style' );
			} );
		} );
	} );
};

export default vCreditComparison;
